import { format } from 'date-fns';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import classes from './SelectDateRange.module.scss';
import { StandardButton } from '../../../../common/Button';

export function getCurDate(f) {
  if (f === undefined) f = 'yyyy-MM-dd';
  const now = Date.now();
  try {
    let date = format(Date.now(), f);
    return date;
  } catch (err) {
    return now;
  }
}

export function getCurTime() {
  return format(new Date(), 'yyyy-MM-dd HH:mm:ss');
}

export const SelectDateRange = ({ onFilterChange }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(
    new Date(new Date().setDate(new Date().getDate() + 1))
  );

  const handleFilter = () => {
    const formattedStartDate = format(startDate, 'yyyy-MM-dd');
    const formattedEndDate = format(endDate, 'yyyy-MM-dd');
    onFilterChange(formattedStartDate, formattedEndDate);
  };


  return (
    <div className={`${classes['custom-datepicker']} custom-datepicker`}>
      <div className={classes['datePicker_wrap']}>
        <span>From:</span>
        <DatePicker
          data-testid="start-date"
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          className={classes['date-picker-input']}
        />
      </div>
      <div className={classes['datePicker_wrap']}>
        <span>To:</span>
        <DatePicker
          data-testid="end-date"
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          className={classes['date-picker-input']}
        />
      </div>
      <div className={classes.buttonWrap}>
        <StandardButton data-testid="submit-date" onClick={handleFilter}>
          Filter Dates
        </StandardButton>
      </div>
    </div>
  );
};
